import React, { createContext, useState, useContext, useEffect, useRef, useCallback } from 'react';
import { CompanyContext } from './CompanyContext';
import { getAuth } from 'firebase/auth';
import axios from 'axios';
import { logger } from '../utils/logger';
import { getBackendUrl } from '../utils/api';

const BACKEND_URL = getBackendUrl();

const ConsultorContext = createContext();

export const ConsultorProvider = ({ children }) => {
  const [consultores, setConsultores] = useState([]);
  const [loading, setLoading] = useState(true);
  const { selectedCompany } = useContext(CompanyContext);
  const unsubscribeRef = useRef(null);

  // Busca consultores via backend
  const refreshConsultores = useCallback(async () => {
    if (!selectedCompany?.companyId) return;
    try {
      const currentUser = getAuth().currentUser;
      if (!currentUser) return;
      const idToken = await currentUser.getIdToken();
      const { data } = await axios.get(
        `${BACKEND_URL}/api/consultores?companyId=${selectedCompany.companyId}`,
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      const list = Array.isArray(data) ? data : (data?.consultores || []);
      setConsultores(list);
    } catch (error) {
      console.error('[ConsultorContext] Erro ao buscar consultores:', error);
      logger.warn('[ConsultorContext] Falha ao carregar consultores');
    }
  }, [selectedCompany?.companyId]);

  useEffect(() => {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (!currentUser || !selectedCompany?.companyId) {
      setLoading(false);
      return;
    }

    setLoading(true);
    refreshConsultores().finally(() => setLoading(false));
  }, [selectedCompany?.companyId, refreshConsultores]);

  const addConsultor = (novoConsultor) => {
    setConsultores((prevConsultores) => [...prevConsultores, novoConsultor]);
  };

  const removeConsultor = (consultorId) => {
    setConsultores((prevConsultores) =>
      prevConsultores.filter((consultor) => consultor.id !== consultorId)
    );
  };

  const stopConsultoresListener = () => {
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
      unsubscribeRef.current = null;
    }
  };

  return (
    <ConsultorContext.Provider
      value={{
        consultores,
        loading,
        addConsultor,
        removeConsultor,
        stopConsultoresListener,
        refreshConsultores,
      }}
    >
      {children}
    </ConsultorContext.Provider>
  );
};

export const useConsultor = () => {
  const context = useContext(ConsultorContext);
  if (!context) {
    throw new Error('useConsultor deve ser usado dentro de um ConsultorProvider');
  }
  return context;
};

export default ConsultorContext; 